import { createActionGroup, props } from '@ngrx/store';
import { Promotion } from '@us/web/shared/data-access';

export const PromotionsActions = createActionGroup({
    source: 'Promotions/API',
    events: {
        'Load Promotions': props<{ shopId?: string; customer_phone?: string | null }>(),
        'Load Promotions Success': props<{ promotions: Promotion[] }>(),
        'Load Promotions Failure': props<{ error: string }>(),
        'Update Promotions': props<{ promotions: Promotion[] }>(),
        'Add Promotions Id Not Use': props<{ ids: number[] }>()
    }
});
